import { ICountryCode } from '../../../contexts/app.context';

const labelOrIso = (countryCode: ICountryCode) => {
  return countryCode.label.length > 15 ? countryCode.iso : countryCode.label;
};

export default labelOrIso;
